import { render } from "./ActivityTab.vue?vue&type=template&id=51ba7b0a&scoped=true"
import script from "./ActivityTab.vue?vue&type=script&lang=js"
export * from "./ActivityTab.vue?vue&type=script&lang=js"

import "./ActivityTab.vue?vue&type=style&index=0&id=51ba7b0a&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ba7b0a"]])

export default __exports__